export type ParsedQuery = {
  raw: string
  mode: 'default' | 'file' | 'command' | 'project' | 'tag' | 'saved-query'
  terms: string
  prefix: string | null
}

type PrefixRule = {
  prefix: string
  mode: ParsedQuery['mode']
}

const PREFIX_RULES: PrefixRule[] = [
  { prefix: 'file:', mode: 'file' },
  { prefix: '/', mode: 'file' },
  { prefix: '>', mode: 'command' },
  { prefix: '@', mode: 'project' },
  { prefix: 'tag:', mode: 'tag' },
  { prefix: '#', mode: 'tag' },
  { prefix: 'query:', mode: 'saved-query' },
]

export function parseQuery(input: string): ParsedQuery {
  for (const rule of PREFIX_RULES) {
    if (input.startsWith(rule.prefix)) {
      return {
        raw: input,
        mode: rule.mode,
        terms: input.slice(rule.prefix.length),
        prefix: rule.prefix,
      }
    }
  }

  return {
    raw: input,
    mode: 'default',
    terms: input,
    prefix: null,
  }
}

export const MODE_LABELS: Record<ParsedQuery['mode'], string> = {
  default: '',
  file: 'Files /',
  command: 'Commands >',
  project: 'Projects @',
  tag: 'Tags #',
  'saved-query': 'Saved Queries query:',
}
